export const ROLLOVER_DATA_RECEIVED = 'ROLLOVER_DATA_RECEIVED'
export const ROLLOVER_DATA_UNLOADED = 'ROLLOVER_DATA_UNLOADED'